module.exports = __webpack_public_path__ + "static/media/loading.cff4ac31.gif";